var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJourney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 151 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.241 46.146a5.183 5.183 0 00-5.177 5.18 5.18 5.18 0 005.177 5.174 5.18 5.18 0 005.177-5.174 5.183 5.183 0 00-5.177-5.18m0 14.791c-5.301 0-9.614-4.31-9.614-9.611 0-5.304 4.313-9.618 9.614-9.618 5.301 0 9.615 4.314 9.615 9.618 0 5.301-4.314 9.611-9.615 9.611",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Journey_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 26,
    width: 50,
    height: 59
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.833 26.917h48.811v57.687h-48.81V26.917z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Journey_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.238 31.354c-11.01 0-19.969 9.044-19.969 20.155 0 14.138 16.638 27.912 19.97 28.646 3.33-.737 19.968-14.51 19.968-28.646 0-11.111-8.958-20.155-19.969-20.155zm0 53.25c-5.307 0-24.406-16.424-24.406-33.095 0-13.56 10.949-24.592 24.406-24.592 13.458 0 24.406 11.031 24.406 24.592 0 16.67-19.099 33.095-24.406 33.095z",
    fill: "currentColor"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.283 74.578a53.24 53.24 0 01-2.989-3.671l-9.47 6.739c-4.874 3.467-4.874 9.089 0 12.556l17.014 12.107c4.873 3.467 12.774 3.467 17.647 0L61.5 90.202c4.873-3.467 4.873-9.089 0-12.556l-8.72-6.205a53.646 53.646 0 01-3.038 3.637l7.684 5.467c2.623 1.866 2.623 4.892 0 6.758L40.41 99.41c-2.623 1.867-6.876 1.867-9.499 0L13.897 87.304c-2.623-1.867-2.623-4.893 0-6.76l8.386-5.966zM125.053 18.77a3.869 3.869 0 00-3.864 3.868 3.866 3.866 0 003.864 3.862 3.867 3.867 0 003.865-3.862 3.87 3.87 0 00-3.865-3.867m0 11.041c-3.957 0-7.177-3.217-7.177-7.174 0-3.96 3.22-7.18 7.177-7.18 3.958 0 7.177 3.22 7.177 7.18 0 3.957-3.219 7.174-7.177 7.174",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Journey_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 4,
    width: 38,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.833 4.417h36.437v43.062h-36.437V4.417z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Journey_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.051 7.73c-8.219 0-14.906 6.75-14.906 15.045 0 10.553 12.419 20.835 14.906 21.383 2.487-.55 14.906-10.832 14.906-21.383 0-8.295-6.687-15.046-14.906-15.046zm0 39.75c-3.962 0-18.219-12.261-18.219-24.705 0-10.123 8.173-18.358 18.219-18.358 10.046 0 18.219 8.235 18.219 18.358 0 12.444-14.257 24.704-18.219 24.704z",
    fill: "currentColor"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.634 39.995a39.537 39.537 0 01-2.231-2.74l-7.07 5.03c-3.638 2.588-3.638 6.785 0 9.373l12.701 9.038c3.638 2.588 9.535 2.588 13.173 0l12.701-9.038c3.638-2.588 3.638-6.785 0-9.373l-6.509-4.632a40.094 40.094 0 01-2.267 2.715l5.735 4.08c1.958 1.394 1.958 3.653 0 5.046l-12.701 9.038c-1.958 1.393-5.133 1.393-7.091 0l-12.701-9.038c-1.958-1.393-1.958-3.652 0-5.045l6.26-4.454z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 84.972s11.55.063 27.065 0 16.307-22.54 0-22.472c-16.307.068-3.636 0-15.35 0-11.715 0-14.947-15.5 0-15.5H105",
    stroke: "currentColor",
    strokeWidth: 4
  })));
}

export default SvgJourney;